const HelloList = [
  {
    country: 'argentina',
    greet: 'Hola',
  },
  {
    country: 'australia',
    greet: 'Hello',
  },
  {
    country: 'cambodia',
    greet: 'chomreabsuor',
  },
  {
    country: 'croatia',
    greet: 'Zdravo',
  },
  {
    country: 'czechRepublic',
    greet: 'Ahoj',
  },
  {
    country: 'denmark',
    greet: 'Hej',
  },
  {
    country: 'england',
    greet: 'Hello',
  },
  {
    country: 'france',
    greet: 'Bonjour',
  },
  {
    country: 'germany',
    greet: 'Hallo',
  },
  {
    country: 'greece',
    greet: 'Chaírete',
  },
  {
    country: 'hongKong',
    greet: 'Neih hou',
  },
  {
    country: 'hungary',
    greet: 'Helló',
  },
  {
    country: 'india',
    greet: 'Namaste',
  },
  {
    country: 'indonesia',
    greet: 'Halo',
  },
  {
    country: 'italy',
    greet: 'Ciao',
  },
  {
    country: 'japan',
    greet: 'Konnichiwa',
  },
  {
    country: 'malaysia',
    greet: 'Hello',
  },
  {
    country: 'morocco',
    greet: 'Salam aleikum',
  },
  {
    country: 'nepal',
    greet: 'Namastē',
  },
  {
    country: 'peru',
    greet: 'Hola',
  },
  {
    country: 'phillippines',
    greet: 'Kamusta',
  },
  {
    country: 'poland',
    greet: 'Cześć',
  },
  {
    country: 'portugal',
    greet: 'Olá',
  },
  {
    country: 'scotland',
    greet: 'hello',
  },
  {
    country: 'singapore',
    greet: 'Hello',
  },
  {
    country: 'southAfrica',
    greet: 'Hello',
  },
  {
    country: 'southKorea',
    greet: 'Annyeong',
  },
  {
    country: 'spain',
    greet: 'Hola',
  },
  {
    country: 'sriLanka',
    greet: 'Hello',
  },
  {
    country: 'sweden',
    greet: 'Hallå',
  },
  {
    country: 'taiwan',
    greet: 'Nǐ hǎo',
  },
  {
    country: 'thailand',
    greet: 'S̄wạs̄dī',
  },
  {
    country: 'theNetherlands',
    greet: 'Hallo',
  },
  {
    country: 'turkey',
    greet: 'Merhaba',
  },
  {
    country: 'unitedArabEmirates',
    greet: 'Asalam alaikum',
  },
  {
    country: 'unitedStates',
    greet: 'Hello',
  },
  {
    country: 'unitedKingdom',
    greet: 'Hello',
  },
  {
    country: 'vietnam',
    greet: 'xin chào',
  },
];

export default HelloList;
